import { Grid, Link, Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import type { IBreed } from "@framework/types";
import { decodeTraits, DND } from "@dzambalaorg/traits-v5";
import { Table, Typography } from "@dzambalaorg/ui-kit";

export interface IBreedItemDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IBreed | null;
}

export const BreedItemDialogView = (props: IBreedItemDialogViewProps) => {
  const { viewItem, open, onConfirm, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { token, tokenId, traits, children } = viewItem;

  const result = traits
    ? Object.entries(decodeTraits(BigInt(traits), DND)).reduce(
        (memo, [key, value]) => Object.assign(memo, { [key]: value }),
        {} as Record<string, any>,
      )
    : { not: "yet" };
  const handleConfirm = (): void => {
    onConfirm();
  };
  const domain = window.location.host;
  const proto = window.location.protocol;

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="breed table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.tokenId" />
              </Table.Cell>
              <Table.Cell align="right">
                {token ? (
                  <Typography variant="body1" color="textSecondary">
                    <Link target={"_blank"} href={`${proto}//${domain}/erc721-tokens/${tokenId || 0}`}>
                      {token.template ? `${token.template?.title} #${token.tokenId}` : tokenId}
                    </Link>
                  </Typography>
                ) : null}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.parents" />
              </Table.Cell>
              <Table.Cell align="right">
                {children?.length ? (
                  <>
                    {/* <Typography variant="body1" color="textSecondary"> */}
                    {/*  <Link */}
                    {/*    target={"_blank"} */}
                    {/*    href={`${proto}//${domain}/erc721-tokens/${children ? children[0]?.matron?.tokenId : 0}`} */}
                    {/*  > */}
                    {/*    {children[0]?.matron?.token?.template?.title} #{children[0]?.matron?.token?.tokenId} */}
                    {/*  </Link> */}
                    {/* </Typography> */}
                    {/* <Typography variant="body1" color="textSecondary"> */}
                    {/*  <Link */}
                    {/*    target={"_blank"} */}
                    {/*    href={`${proto}//${domain}/erc721-tokens/${children ? children[0]?.sire?.tokenId : 0}`} */}
                    {/*  > */}
                    {/*    {children[0]?.sire?.token?.template?.title} #{children[0]?.sire?.token?.tokenId} */}
                    {/*  </Link> */}
                    {/* </Typography> */}
                  </>
                ) : (
                  "genesisZero"
                )}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.traits" />
              </Table.Cell>
              <Table.Cell align="right">
                {traits ? (
                  <Grid container>
                    {Object.entries(result).map(([key, value]) => (
                      <Grid key={key} container>
                        <Grid size={{ xs: 6 }}>
                          <FormattedMessage id={`enums.geneName.${key}`} />
                        </Grid>
                        <Grid size={{ xs: 6 }}>{value}</Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : null}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
